// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__FG2pT","title":"Images45_title__1zlJk","images":"Images45_images__ixn0K"};